import { isEmpty, omitBy } from "lodash";

export default function getUtmParamsFromQueryParams(params) {
  return omitBy(
    {
      utmSource: params.get("utm_source"),
      utmMedium: params.get("utm_medium"),
      utmCampaign: params.get("utm_campaign"),
    },
    isEmpty,
  );
}
